import { persistReducer } from "redux-persist";
import { getVideoConstraints } from "src/modules/rtc/media-constraints";
import AppStatus from "src/constants/AppStatus";
import Presence from "src/constants/presence";
import VideoMode from "src/constants/videoMode";
import { createSlice } from "@reduxjs/toolkit";
import { signOutRequest } from "src/modules/auth/duck/actions";

const initialState = {
  status: AppStatus.STARTING,
  presence: Presence.UNAVAILABLE,
  wasInDashboardBefore: false,
  hasSeenMonitoringHelp: false,
  themeSource: "system",
  videoQuality: getVideoConstraints({ videoQuality: "MEDIUM" }).id,
  videoMode: VideoMode.COVER,
  autoUpdateVideoMode: true,
  isInDetachMode: false,
  whatsNewContentVersion: null,
  enableDebug: false,
  lastRole: null // baby | parent
};
const appSlice = createSlice({
  initialState,
  name: "app",
  reducers: {
    appStartSuccess(state) {
      state.status = AppStatus.STARTED;
    },
    appFailure(state) {
      state.status = AppStatus.FAILURE;
    },
    appAlreadyOpen(state) {
      state.status = AppStatus.ALREADY_OPEN;
    },
    connectionLost(state) {
      state.status = AppStatus.CONNECTION_LOST;
    },
    connectionReestablished(state) {
      state.status = AppStatus.STARTED;
    },
    appReset(state) {
      state.status = AppStatus.SIGNING_OUT;
    },
    enterInactiveMode(state) {
      state.status = AppStatus.INACTIVE_MODE;
    },
    presenceUpdated(state, { payload }) {
      state.presence = payload;
    },
    appRestart(state) {
      return (state = {
        ...initialState,
        wasInDashboardBefore: state.wasInDashboardBefore
      });
    },
    enteredDashboard(state) {
      state.wasInDashboardBefore = true;
    },
    themeSourceChanged(state, { payload }) {
      state.themeSource = payload;
    },
    sawMonitoringHelp(state) {
      state.hasSeenMonitoringHelp = true;
    },
    videoQualityChanged(state, { payload }) {
      state.videoQuality = payload;
    },
    detachModeChanged(state, { payload }) {
      state.isInDetachMode = payload;
    },
    whatsNewContentVersionChanged(state, { payload }) {
      state.whatsNewContentVersion = payload;
    },
    enableDebugChanged(state, { payload }) {
      state.enableDebug = payload;
    },
    videoModeChanged(state, { payload }) {
      state.videoMode = payload;
    },
    autoUpdateVideoMode(state, { payload }) {
      state.autoUpdateVideoMode = payload;
    },
    lastRoleChanged(state, { payload }) {
      state.lastRole = payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(signOutRequest, (state) => {
      state.status = AppStatus.SIGNING_OUT;
    });
  }
});

export { appSlice };
export default {
  createReducer: (storage) => {
    const persistConfig = {
      key: "app",
      whitelist: [
        "wasInDashboardBefore",
        "hasSeenMonitoringHelp",
        "themeSource",
        "videoQuality",
        "videoMode",
        "autoUpdateVideoMode",
        "whatsNewContentVersion",
        "lastRole"
      ],
      storage
    };

    return persistReducer(persistConfig, appSlice.reducer);
  }
};
